// utils/taskIdUtils.js

/**
 * Extracts the numeric portion of task IDs and finds the highest number
 * @param {Array} subtasks - Array of subtask objects with IDs in format "task-X"
 * @returns {number} - Next available task ID number
 */
export const getNextTaskId = (subtasks) => {
    if (!subtasks || subtasks.length === 0) {
      return 0;
    }

    // Extract numbers from task IDs and find the highest one
    const currentIds = subtasks.map(task => {
      const match = task.id.match(/^task-(\d+)$/);
      return match ? parseInt(match[1], 10) : -1;
    });

    return Math.max(...currentIds) + 1;
  };

  /**
   * Creates a new task ID string
   * @param {number} idNumber - The numeric portion of the task ID
   * @returns {string} - Formatted task ID string
   */
  export const createTaskId = (idNumber) => `task-${idNumber}`;